module.exports = __webpack_public_path__ + "static/img/rsndd.159c0c64.jpg";